module.exports = __webpack_public_path__ + "static/media/bgpperi.410d70f1.jpg";